import './index.scss';

import imgcredito4 from '../../../../../assets/images/para-sua-empresa/img-credito/img-credito4@2x.png';

export const NCE = () => {

    return (
        <div className='container-select-credit'>
            <div className='cont-dados-1'>
                <h1> NCE - Nota de crédito ao exportador </h1>

                <p>
                    Uma nota de crédito ao exportador é um documento emitido por um
                    exportador (vendedor) a um importador (comprador) para reduzir o
                    valor de uma fatura original. Ela funciona como um crédito a favor do
                    importador, diminuindo o valor que ele deve pagar.
                </p>

                <p>
                    Existem várias razões pelas quais uma nota de crédito de exportação
                    pode ser emitida, incluindo:
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Mercadorias incorretas: </span>
                    Se o exportador enviar as mercadorias
                    incorretas, ele emitirá uma nota de crédito para o valor das mercadorias
                    incorretas.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Devolução de mercadorias: </span>
                    Se o importador devolver as mercadorias ao
                    exportador, este emitirá uma nota de crédito para o valor das
                    mercadorias devolvidas.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}>  Diferenças de preço: </span>
                    Se houver uma diferença entre o preço cotado e o
                    preço faturado, o exportador pode emitir uma nota de crédito para
                    corrigir a diferença.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Acordos comerciais: </span>
                    Às vezes, como parte de uma negociação ou acordo
                    comercial, o exportador pode oferecer um desconto ou bonificação,
                    formalizado através de uma nota de crédito.
                </p>

                <p>
                    <span style={{ fontWeight: 'bold' }}> Ajustes de qualidade ou quantidade: </span>
                    Se a qualidade ou quantidade das
                    mercadorias não corresponder ao acordado, uma nota de crédito pode
                    ser emitida para compensar o importador.
                </p>

                <p>
                    É importante que tanto o exportador quanto o importador mantenham
                    registros precisos das notas de crédito emitidas e recebidas. Isso ajuda a
                    garantir que os pagamentos sejam feitos corretamente e que quaisquer
                    discrepâncias sejam resolvidas rapidamente.
                </p>

            </div>
            <div className='cont-dados-2'>
                <img alt={imgcredito4} src={imgcredito4} />
                <div>
                    <h1> Vantagens </h1>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Melhora o relacionamento com o cliente: </span>
                        Demonstra
                        profissionalismo e comprometimento em resolver
                        problemas, fortalecendo a confiança e a fidelidade do
                        importador.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Mantém a reputação da empresa: </span>
                        Emitir notas de
                        crédito quando justificado protege a imagem da
                        empresa como justa e confiável.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Facilita a resolução de disputas: </span>
                        Oferece uma maneira
                        formal e documentada de corrigir erros, minimizando o
                        potencial para disputas prolongadas e custosas.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Reduz o risco de perda de vendas futuras: </span>
                        Ao resolver
                        problemas de forma rápida e eficiente, o exportador
                        aumenta a probabilidade de futuras transações com o
                        mesmo importador.
                    </p>

                    <p>
                        <span style={{ fontWeight: 'bold' }}>Simplifica a contabilidade: </span>
                        As notas de crédito
                        fornecem um registro claro das correções feitas nas
                        faturas, facilitando a reconciliação e o controle financeiro.
                    </p>

                    <div className='buttons-style inv' >
                        <a href='https://wa.me/5511973667387' target="_blank" rel="noopener noreferrer" > Fale com um especialista </a>
                    </div>                </div>
            </div>
        </div>

    )
}

